import { render } from "./UiFormItem.vue?vue&type=template&id=4f4cb456"
import script from "./UiFormItem.vue?vue&type=script&lang=js"
export * from "./UiFormItem.vue?vue&type=script&lang=js"

import "./UiFormItem.vue?vue&type=style&index=0&id=4f4cb456&lang=css"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__